/* eslint-disable */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const fetchExchangeRates = createAsyncThunk(
  'exchange/fetchExchangeRates',
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch('https://api.exchangerate-api.com/v4/latest/USD');
      if (!res.ok) throw new Error('Failed to fetch exchange rates');
      const data = await res.json();
      return data.rates || {};
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const exchangeSlice = createSlice({
  name: 'exchange',
  initialState: {
    rates: {},
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchExchangeRates.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchExchangeRates.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.rates = action.payload;
      })
      .addCase(fetchExchangeRates.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default exchangeSlice.reducer;